<script lang="js" setup>
import IconChevronDown from '~/assets/images/common/icon-chevron-down.svg'
import { useElementSize, useScroll } from '@vueuse/core'
import { useRtl } from '~/hooks'

defineProps({
  contentClass: {
    type: String,
    default: '',
  },

})
const lrRef = ref()
const { isRtl } = useRtl()

const containerSize = useElementSize(() => lrRef.value?.scrollbarInstRef.containerRef)
const contentSize = useElementSize(() => lrRef.value?.scrollbarInstRef.contentRef)

const isOverflow = computed(() => toValue(containerSize.width) < toValue(contentSize.width))
const { arrivedState } = useScroll(() => lrRef.value?.scrollbarInstRef.containerRef)

const prevBtnVisible = computed(() => isOverflow.value && (isRtl.value ? !arrivedState.right : !arrivedState.left))
const nextBtnVisible = computed(() => isOverflow.value && (isRtl.value ? !arrivedState.left : !arrivedState.right))

function scroll(left) {
  lrRef.value.scrollBy({ left, behavior: 'smooth' })
}
</script>

<template>
  <n-scrollbar ref="lrRef" x-scrollable :size="1" trigger="none" :content-class="`flex items-center ${contentClass}`" class="[&_.n-scrollbar-rail]:!hidden">
    <button v-show="prevBtnVisible" class="sticky start-0 bg-fillPagePrimary h-full pe-2" @click="scroll(-300)">
      <IconChevronDown class="w-4 h-4 rotate-90 cursor-pointer rtl:-scale-100" />
    </button>
    <div class="flex items-center">
      <slot />
    </div>
    <button v-show="nextBtnVisible" class="sticky end-0 bg-fillPagePrimary h-full ps-2" @click="scroll(300)">
      <IconChevronDown class="w-4 h-4 -rotate-90 cursor-pointer rtl:-scale-100" />
    </button>
  </n-scrollbar>
</template>
